import { useState } from "react";
import { useCopyFeedback } from "../hooks/useCopyFeedback";
import { Button } from "./ui/Button";
import { Icon } from "./ui/Icon";

export interface CallbackSecretDisplay {
  readonly appId: string;
  readonly value: string | null;
  readonly version: number | null;
}

/** 临时展示已授权读取的当前密钥；默认掩码，不向 tooltip 或隐藏 DOM 写入明文。 */
export function CallbackSecretPanel({ display, onClose }: {
  readonly display: CallbackSecretDisplay;
  readonly onClose: () => void;
}) {
  const [visible, setVisible] = useState(false);
  const { copied, copy } = useCopyFeedback(display.value ?? "");

  return (
    <section className="surface-card callback-secret-panel" aria-label="临时回调密钥" role="status">
      <div className="callback-secret-copy">
        <span className="callback-secret-icon"><Icon name="key" size={18} /></span>
        <div>
          <h3>{display.value === null ? "正在读取应用回调密钥" : "当前应用回调密钥"}</h3>
          <p>当前应用的四类回调共用；60 秒后自动隐藏，关闭、切换或离开页面会清空。</p>
          <p><code>{display.appId}</code> · APPLICATION{display.version === null ? " · 密钥版本请见应用密钥状态" : ` · 密钥 v${display.version}`}</p>
          <p>请仅保存于业务服务端 Secret 管理系统；关闭不会清除您主动复制到剪贴板的内容。</p>
        </div>
      </div>
      <div>
        {display.value === null ? null : (
          <div className="copy-field copy-field-sensitive">
            <span>Callback Secret</span>
            <div><code>{visible ? display.value : "••••••••••••••••••••••••"}</code></div>
          </div>
        )}
        <div className="callback-secondary-actions">
          {display.value === null ? null : <Button type="button" variant="ghost" onClick={() => { setVisible((value) => !value); }}>{visible ? "隐藏密钥" : "显示密钥"}</Button>}
          {display.value === null ? null : <Button aria-label="复制密钥" type="button" variant="ghost" onClick={() => { void copy(); }}>{copied ? "已复制" : "复制密钥"}</Button>}
          <Button type="button" variant="ghost" onClick={onClose}>关闭密钥</Button>
        </div>
      </div>
    </section>
  );
}
